import React from 'react';
import { NavLink } from 'react-router-dom';
import {  trans } from '../utils';
const LeftSideBarItem = ({ MenuItem } = {}) => {
  if (!MenuItem) return null;

  return (
    <div
      onClick={(e) => e.stopPropagation()}
      className="menu-item"
    >
      <NavLink
        to={"/" + MenuItem.route}
        className={({ isActive }) =>
          isActive ? "menu-link active" : "menu-link"
        }
      >
        <span className="menu-icon">
          <i className={MenuItem.icon}></i>
        </span>
        <span className="menu-title">{trans(MenuItem.name_en)}</span>
      </NavLink>
    </div>
  );
};
export default LeftSideBarItem;
